<script lang="ts" setup>
  
  // Idioma
  const { locale, t } = useI18n()

  definePageMeta({ // forzar a usar light mode
    colorMode: 'light'
  })
  
  // SEO
  useSeoMeta({
    title: "Mundo Joven: Reserva hoteles por horas en todo el mundo",
    description: "Reserva habitaciones por horas con total flexibilidad y elige tu hora de check-in. Descubre más de 4.000 hoteles de 3, 4 y 5 estrellas en más de 25 países. Disfruta de todos los servicios del hotel con cancelación gratuita. Vive la experiencia de viaje más flexible con Mundo Joven, en colaboración con BYHOURS.",
    keywords: "Hoteles por horas, hotel flexible, reserva por horas, habitaciones de hotel, microestancias, hoteles en Barcelona, hoteles en Madrid, hoteles en México, hoteles en Buenos Aires, hoteles para descansar, dayuse, hotel cerca del aeropuerto, hotel para trabajar, hotel de paso, reserva flexible, check-in a medida",
    ogTitle: "Mundo Joven: Reserva hoteles por horas en todo el mundo",
    ogDescription: "Reserva habitaciones por horas con total flexibilidad y elige tu hora de check-in. Descubre más de 4.000 hoteles de 3, 4 y 5 estrellas en más de 25 países. Disfruta de todos los servicios del hotel con cancelación gratuita. Vive la experiencia de viaje más flexible con Mundo Joven, en colaboración con BYHOURS."
  })

  // Strapi
  const strapiData = await getStrapiData('home-page', {
    locale: locale.value
  })

</script>

<template>

  <!-- Hero -->
  <HomeHero :titulo="strapiData?.titulo" :subtitulo="strapiData?.subtitulo" />

  <div class="w-full">

    <!-- Beneficios -->
    <div class="my-16 sm:my-16 max-w-screen-2xl mx-auto px-5">
      <HomeTitulo :info="strapiData?.beneficios" width="w-1/3">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-10 sm:py-12">
          <div v-for="item in strapiData?.beneficios?.feature" class="flex flex-col">
            <UIcon class="text-3xl -ml-1 mb-1" dynamic :name="`i-heroicons-${item?.icon}`" />
            <p class="font-bold text-lg pb-1">{{ item?.titulo }}</p>
            <p class="text-neutral-500">{{ item?.texto }}</p>
          </div>
        </div>
      </HomeTitulo>
    </div>

    <!-- Separador ciudades -->
    <div class="max-w-screen-2xl mx-auto my-10 sm:my-32 relative">
      <div class="w-full h-full absolute rounded-3xl px-4">
        <NuxtImg provider="s3Provider" alt="Fondo ciudades" loading="lazy" src="/home/fondoCiudades_2.webp"
          class="w-full h-full rounded-3xl object-cover" />
      </div>
      <UMarquee :overlay="false" :ui="{ root: 'py-12 sm:py-24' }">
        <span :alt="ciudad.titulo" v-for="ciudad in strapiData?.listaCiudades"
          class="py-6 mx-10 text-8xl md:text-9xl font-bold text-white shrink-0">{{ ciudad?.titulo }}</span>
      </UMarquee>
    </div>


    <!-- Cómo funciona -->
    <HomeImageCard>
      <div class="h-80 lg:h-[90vh]">
        <NuxtImg provider="s3Provider" alt="Cómo funciona" loading="lazy" src="/home/comofunciona.webp"
          class="w-full h-full object-cover rounded-3xl" />
      </div>
      <div class="py-8 md:p-16 flex flex-col justify-center">
        <HomeTitulo :info="strapiData?.comoFunciona" width="w-full md:w-full">
          <ul class="list-none gap-6 md:gap-8 flex flex-col">
            <li v-for="item in strapiData?.comoFunciona?.feature" class="flex pb-2">
              <div class="flex items-center mr-6">
                <UIcon class="text-3xl" dynamic :name="`i-lucide-${item.icon}`" />
              </div>
              <div>
                <p class="font-bold text-lg">{{ item.titulo }}</p>
                <p class="text-neutral-500">{{ item.texto }}</p>
              </div>
            </li>
          </ul>
        </HomeTitulo>
      </div>
    </HomeImageCard>

    <!-- Hoteles -->
    <div class="my-16 sm:my-28 max-w-screen-2xl mx-auto px-5">
      <HomeTitulo :info="strapiData?.marqee">
        <UMarquee :repeat="6" :ui="{ root: '[--duration:50s]' }">
          <NuxtImg v-for="(index) in 27" :key="index" provider="s3Provider" :src="`/home/logoHoteles/${index + 1}.svg`"
            alt="Logo hoteles" loading="lazy" width="80" height="40"
            class="grayscale opacity-50 mr-16 md:mr-28 py-6 shrink-0" />
        </UMarquee>
      </HomeTitulo>
    </div>

  </div>
</template>